module.exports = __webpack_public_path__ + "static/media/P12.3cc59322.jpg";